import { Input, type InputProps } from "antd";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { FormItem, type FormItemProps } from "~components/Form/FormItem";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;

  /** `disabled` moved out of `inputProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `InputProps` */
  inputProps?: Omit<InputProps, "disabled">;
};

export const FormInput = <TForm = unknown>({ label, disabled, inputProps, ...rest }: Props<TForm>) => {
  const { formatMessage } = useIntl();

  let placeholder = inputProps?.placeholder;
  if (!placeholder) {
    placeholder = typeof label === "string" ? label : formatMessage({ id: `form.field.label.${rest.name}` });
  }

  const content = (
    <FormItem<TForm> className="form-input-item" layout="vertical" label={label} {...rest}>
      <Input disabled={disabled} {...inputProps} placeholder={placeholder} />
    </FormItem>
  );

  return rest.hidden ? content : <div>{content}</div>;
};
